export default [
  {
    fullName: 'АЛЕКСЕЙ ВАСИЛЬЕВ',
    description: 'Генеральный продюсер Flowcon, Россия',
    photo: require('@/assets/speakers/speaker-1.jpg')
  },
  {
    fullName: 'ТАТЬЯНА КРОС',
    description: 'Системный аналитик Гигатех, Россия',
    photo: require('@/assets/speakers/speaker-2.jpg')
  },
  {
    fullName: 'РОМАН ПАНИН',
    description: 'Руководитель группы развития BI-систем Пандикс, Россия',
    photo: require('@/assets/speakers/speaker-3.jpg')
  },
  {
    fullName: 'ВЕРОНИКА ЖЕЛНОВА',
    description: 'Автор нескольких курсов по разработке и управлению требованиями, управлению проектами, разработке и документированию системной архитектуры. Предприниматель, Россия',
    photo: require('@/assets/speakers/speaker-4.jpg')
  },
  {
    fullName: 'ИВАН САПРАНОВ',
    description: 'Product Analyst SpostmasterLab, Армения',
    photo: require('@/assets/speakers/speaker-5.jpg')
  },
  {
    fullName: 'Оксана Вельмитаминова',
    description: 'Заместитель председателя, член правления банка "Вперед, и точка!", Россия',
    photo: require('@/assets/speakers/speaker-6.jpg')
  }
]
